import { render, staticRenderFns } from "./createLive.vue?vue&type=template&id=6b817b8a&scoped=true&"
import script from "./createLive.vue?vue&type=script&lang=js&"
export * from "./createLive.vue?vue&type=script&lang=js&"
import style0 from "./createLive.vue?vue&type=style&index=0&id=6b817b8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b817b8a",
  null
  
)

export default component.exports